/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Agents_TitleInputs */

const en_mk_agents_title = /** @type {(inputs: Mk_Agents_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Works with the agent you already use`)
};

const id_mk_agents_title = /** @type {(inputs: Mk_Agents_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jalan dengan agent yang sudah kamu pakai`)
};

/**
* | output |
* | --- |
* | "Works with the agent you already use" |
*
* @param {Mk_Agents_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_agents_title = /** @type {((inputs?: Mk_Agents_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Agents_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_agents_title(inputs)
	return en_mk_agents_title(inputs)
});